import { scroller } from 'react-scroll';
import React from 'react';

const reducer = (state, { type, payload }) => {
  switch (type) {
    case 'showEnquiryForm':
      payload && payload.scroll && scroller.scrollTo('contact', {
        offset: 0,
        duration: 1500,
        smooth: 'easeInOutQuint',
        ...payload,
      });
      return { ...state, showEnquiryForm: true, contactSent: false };
    case 'contactSent':
      return { ...state, contactSent: true, showEnquiryForm: false };
    default:
      throw new Error();
  }
};

const defaultState = {
  showEnquiryForm: false,
  contactSent: false,
};

const EnquiryContext = React.createContext();

export default EnquiryContext;
export {
  defaultState,
  reducer,
};
